import './App.css';
import './App.styles.scss';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import PrivateRoutes from './utils/PrivateRoutes'
import OutLoginLayout from './layouts/out-login/out-login';
import InLoginLayout from './layouts/in-login/in-login';
import General from './pages/general/general';
import { AnimatePresence } from 'framer-motion';
import Book from './pages/book/book';
import Register from './layouts/register/Register';
import PrivateAdminRoutes from './components/PrivateAdminRoutes'
import UserActive from './pages/user/userActive';
import UserBlock from './pages/user/userBlock';
import Staff from './pages/staff/staff';
import History from './pages/history/history';
import Profile from './pages/profile/profile';
import UploadBook from './pages/book/uploadBook';
import Author from './pages/author/author';
import Category from './pages/category/category';
import Publisher from './pages/publisher/publisher';
import ChangePassword from './components/ChangePassword/ChangePassword';
import ForgotPassword from './layouts/forgot-password/forgot-password';
import ResetPasswordFail from './components/resetPassword/resetPasswordFail';
import ResetPassword from './components/resetPassword/resetPassword';
import ResetPasswordSuccess from './components/resetPassword/resetPasswordSuccess';
import Order from './pages/order/order';
import NotFound from './pages/notFound/notFound';
import Voice from './pages/voice/voice';
import Banner from './pages/banner/banner';
import Translator from './pages/translator/translator';
import Voucher from './pages/voucher/voucher';
import UserHistory from './pages/user-history/UserHistory';
import Tags from './pages/tags/tags';
import VipManagement from './pages/vip/vip';
import SocialMediaPage from './pages/social-media/social-media';
import NotificationPage from './pages/notification/notification';
import DeviceTokensPage from './pages/device-tokens/device-tokens';
import HomeLayoutPage from './pages/home-layout/home-layout';

function App() {
  
  return (
    <div className="App">
      <AnimatePresence>
        <Router>
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route element={<InLoginLayout />} path="/management" >
                <Route element={<Book />} path="/management" />
                <Route element={<Book />} path="/management/book" />
                <Route element={<UploadBook />} path="/management/add-book" />
                <Route element={<Author />} path="/management/author" />
                <Route element={<Publisher />} path="/management/publisher" />
                <Route element={<Category />} path="/management/category" />
                <Route element={<Order />} path="/management/orders" />
                <Route element={<UserActive />} path="/management/user-active" />
                <Route element={<UserBlock />} path="/management/user-block" />
                <Route element={<Staff />} path="/management/staff" />
                <Route element={<History />} path="/management/history" />
                <Route element={<UserHistory />} path="/management/user-history" />
                <Route element={<Profile />} path="/management/profile" />
                <Route element={<ChangePassword />} path="/management/changepassword" />
                <Route element={<Voice />} path="/management/voice" />
                <Route element={<Banner />} path="/management/banner" />
                <Route element={<Translator />} path="/management/translator" />
                <Route element={<Tags />} path="/management/tags" />
                <Route element={<Voucher />} path="/management/voucher" />
                <Route element={<VipManagement />} path="/management/vip" />
                <Route element={<SocialMediaPage />} path="/management/social-media" />
                <Route element={<NotificationPage />} path="/management/notification" />
                <Route element={<DeviceTokensPage />} path="/management/device-tokens" />
                <Route element={<HomeLayoutPage />} path="/management/home-layout" />
              </Route>
            </Route>
            <Route element={<OutLoginLayout />} path="/" />
            <Route element={<OutLoginLayout />} path="/login" />
            <Route element={<Register />} path="/register" />
            <Route element={<ForgotPassword />} path="/forgot-info"/>
            <Route element={<ForgotPassword />} path="/forgot-password"/>
            <Route element={<ResetPassword />} path="/reset-password"/>
            <Route element={<ResetPasswordSuccess />} path="/forgot-password/newpass"/>
            {/* Not Found */}
            <Route element={<NotFound />} path="*" />
          </Routes>
        </Router>
      </AnimatePresence>
    </div>
  );
}

export default App;
